import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardName from "../../../../components/global/CardName";
import { listClear as clearWidget } from '../../../../reducers/models/widgetData';
import ModalComplete from "./ModalComplete";
import Widget from "../../../../components/card/widget/Widget";
import CardProjectChange from "../../../../components/card/project/CardProject";
import CardUser from "../../../../components/card/CardUser";
import ButtonAction from "../../../../components/global/ButtonAction";
import WidgetItemPriority from "../../../../components/card/widget/WidgetItemPriority";
import WidgetItemLabel from "../../../../components/card/widget/WidgetItemLabel";

function ModalUpdate({ show, onHide, model, calendar }) {

    const id_object = 6;

    const dispatch = useDispatch();

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    const stateSize = useSelector((state) => state.size);//Размеры окна
    const stateWidgetData = useSelector((state) => state.widgetData);//Данные для виджета

    const [widgetEditing, setWidgetEditing] = useState(false);

    //const [idTask, setIdTask] = useState(null);
    //const [idTaskR, setIdTaskR] = useState(null);
    //const [formName, setFormName] = useState('Название задачи...');
    //const [formIdType, setFormIdType] = useState(1);//Выполнят один из ответственных
    //const [formIdProject, setFormIdProject] = useState(null);

    const [modalCompleteShow, setModalCompleteShow] = useState(false);

    useEffect(() => {
        //Действия при открытии модального окна
        if (show === true) {
            /*setFormName(model.Name);
             setFormIdType(model.ID_Type);
             setFormIdProject(model.ID_Project);
             setIdTask(model.ID);
             setIdTaskR(model.ID_TaskR);*/
        }
    }, [show]);

    const refHeader = useRef(null);//Шапка карточки
    const refFooter = useRef(null);//Footer карточки
    const [hightBody, setHightBody] = useState(0);

    useEffect(() => {
        if (refHeader.current !== undefined & refFooter.current !== undefined & stateSize.desktop !== true) {
            setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - refFooter.current.offsetHeight - 90)
        }
        if (refHeader.current !== undefined & stateSize.desktop === true) {
            setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - 130)
        }
    }, [refHeader, refFooter, stateSize, model, stateWidgetData.list]);

    //Событие при  закрытии модального окна
    function eventModalClose() {
        onHide();
        //ОЧИЩАЕМ ФОРМУ           
        //setFormName(null);
        setLoading(false);
        setLog(null);
        dispatch(clearWidget());//Очищаем виджеты
    }

    return (
        <>
            {modalCompleteShow === true && (<ModalComplete onHide={() => setModalCompleteShow(false)} show={modalCompleteShow} onHideCard={onHide} model={model} />)}

            {stateSize.desktop === true ?
                (
                    <Modal show={show} onHide={() => eventModalClose()} size="lg">
                        <Modal.Body>
                            <div className="modal_close" onClick={() => eventModalClose()}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>

                            <div className="row" >
                                <div className="col-md-8" /*style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 100, overflow: 'auto' }}*/>
                                    <div ref={refHeader}>
                                        <div>
                                            <CardName name={model.Name} onlyRead={true} />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div>
                                                <CardProjectChange idTask={model.ID} idProject={model.ID_Project} idObject={id_object} idSelected={model.ID_Project} onlyRead={true} />
                                            </div>
                                            <div style={{ marginLeft: 'auto' }}>
                                                {stateWidgetData.listStandart.filter(a => a.ID_Widget === 2).length > 0 && (
                                                    <WidgetItemPriority idObject={id_object} idWidget={2} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 2)[0].Number} idItem={model.ID} onlyRead={true} />
                                                )}
                                            </div>
                                        </div>
                                        {stateWidgetData.listStandart.filter(a => a.ID_Widget === 3).length > 0 && (
                                            <WidgetItemLabel idTab={calendar === true ? -1 : model.id_tab} idObject={id_object} idWidget={3} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 3)[0].Number} idItem={model.ID} idItem2={model.ID_TaskR} onlyRead={true} />)
                                        }
                                    </div>
                                    <div style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: hightBody, overflow: 'auto' }}>
                                        <Widget idObject={id_object} idTab={calendar === true ? -1 : model.id_tab} idItem={model.ID} idItem2={model.ID_TaskR} editMode={widgetEditing} idProject={model.ID_Project} onlyRead={true} />
                                    </div>
                                </div>
                                <div className="col-md-4" style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 100, overflow: 'auto' }}>
                                    {model.Completed_User === false && (
                                        <>
                                            <div className="card-block-title">Действия</div>
                                            <div><ButtonAction typeBtn='finish' onClick={() => setModalCompleteShow(true)} /></div>
                                        </>
                                    )}
                                    <div className="card-block-title">Ответственные</div>
                                    <CardUser idItem={model.ID} idObject={id_object} idType={model.ID_Type} idProject={model.ID_Project} onlyRead={true} />
                                </div>
                            </div>
                            {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                        </Modal.Body>
                    </Modal >
                )
                :
                (
                    <Modal show={show} onHide={() => eventModalClose()} size="lg">
                        <Modal.Body>
                            <div className="modal_close" onClick={() => eventModalClose()}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>

                            <div ref={refHeader}>
                                <div>
                                    <CardName name={model.Name} onlyRead={true} />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        <CardProjectChange idTask={model.ID} idProject={model.ID_Project} idObject={id_object} idSelected={model.ID_Project} onlyRead={true} />
                                    </div>
                                    <div style={{ marginLeft: 'auto' }}>
                                        {stateWidgetData.listStandart.filter(a => a.ID_Widget === 2).length > 0 && (
                                            <WidgetItemPriority idObject={id_object} idWidget={2} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 2)[0].Number} idItem={model.ID} onlyRead={true} />
                                        )}
                                    </div>
                                </div>
                                {stateWidgetData.listStandart.filter(a => a.ID_Widget === 3).length > 0 && (
                                    <WidgetItemLabel idObject={id_object} idWidget={3} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 3)[0].Number} idItem={model.ID} idItem2={model.ID_TaskR} onlyRead={true} />)
                                }
                            </div>

                            <div key={hightBody} style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: hightBody, overflow: 'auto' }}>
                                <Widget idObject={id_object} idTab={calendar === true ? -1 : model.id_tab} idItem={model.ID} idItem2={model.ID_TaskR} editMode={widgetEditing} idProject={model.ID_Project} onlyRead={true} />
                            </div>

                            <div ref={refFooter}>
                                <hr></hr>
                                <CardUser idItem={model.ID} idObject={id_object} idType={model.ID_Type} idProject={model.ID_Project} onlyRead={true} />
                                <hr></hr>

                                <div style={{ height: '55px' }}>
                                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                                    <div className="m_btn_block_footer">
                                        {model.Completed_User === false && (
                                            <div><ButtonAction typeBtn='finish' onClick={() => setModalCompleteShow(true)} /></div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal >
                )}

        </>
    );
}
export default ModalUpdate;
